module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_5.44bf4246.png";